/**
 * KEY==Value for equality checks
 */
export enum AdapterTypeEnum {
  T1 = 'T1',
  T2 = 'T2',
  A10 = 'A10',
  L2 = 'L2',
}
